import "./CoreValues.css"; 
import {
  FaAward,
  FaHandshake,
  FaShieldAlt,
  FaLeaf,
} from "react-icons/fa";

const values = [
  {
    title: "Quality",
    desc: "Delivering premium products that consistently exceed expectations.",
    icon: <FaAward />,
  },
  {
    title: "Reliability",
    desc: "Dependable supply chains and customer-focused service.",
    icon: <FaHandshake />,
  },
  {
    title: "Integrity",
    desc: "Honest, transparent and ethical business relationships.",
    icon: <FaShieldAlt />,
  },
  {
    title: "Sustainability",
    desc: "Supporting environmentally responsible sourcing and practices.",
    icon: <FaLeaf />,
  },
];

export default function CoreValues() {
  return (
    <section className="values-section">
      <h2>Our Core Values</h2>

      <p>
        The principles that guide everything we do.
      </p>

      <div className="value-grid">
        {values.map((item, index) => (
          <div className="value-card" key={index}>
            <div className="value-icon">
              {item.icon}
            </div>

            <h4>{item.title}</h4>

            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}